import React, { useEffect, useState, useRef } from "react";

interface InputValidationTooltipProps {
    message: string;
    show: boolean;
    targetRef: React.RefObject<HTMLInputElement | null>;
}

const InputValidationTooltip = ({ message, show, targetRef }: InputValidationTooltipProps) => {
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const tooltipRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (show && targetRef.current) {
            const rect = targetRef.current.getBoundingClientRect();
            setPosition({
                top: rect.top - 55,
                left: rect.left + rect.width / 2,
            });
        }
    }, [show, targetRef]);

    if (!show) return null;

    return (
        <div
            ref={tooltipRef}
            className="fixed z-50 pointer-events-none -translate-x-1/2"
            style={{
                top: `${position.top}px`,
                left: `${position.left}px`,
            }}
        >
            <div className="relative">
                <div className="bg-base-100 border border-gray-200 rounded px-2 py-1 h-7 max-w-[300px] flex items-center shadow-sm">
                    <span className="text-warning-content text-sm font-medium leading-5">{message}</span>
                </div>
                {/* Arrow pointing down */}
                <div className="absolute left-1/2 -translate-x-1/2 -bottom-2 w-0 h-0 border-l-[8px] border-r-[8px] border-t-[8px] border-l-transparent border-r-transparent border-t-gray-200" />
                <div className="absolute left-1/2 -translate-x-1/2 -bottom-[7px] w-0 h-0 border-l-[7px] border-r-[7px] border-t-[7px] border-l-transparent border-r-transparent border-t-white" />
            </div>
        </div>
    );
};

export default InputValidationTooltip;
